// Quiz doboru tieru. Bez backendu, bez zapisu, bez bramki mailowej.
// Stan siedzi w hashu URL, wiec wynik da sie wyslac i dziala przycisk wstecz.
//
// Pytanie 1 wybiera tier i tylko ono. Pytania 2-4 zmieniaja tresc strony
// wyniku, nigdy produkt - inaczej rekomendacja stalaby sie obietnica dochodu.
(() => {
  const root = document.querySelector('[data-aiofm-quiz]');
  if (!root) return;

  const form = root.querySelector('[data-aiofm-quiz-form]');
  const out = root.querySelector('[data-aiofm-result]');
  const pool = root.querySelector('[data-aiofm-buy-pool]');
  const nextBtn = root.querySelector('[data-aiofm-next]');
  const backBtn = root.querySelector('[data-aiofm-back]');
  const progress = root.querySelector('[data-aiofm-progress]');
  const steps = [...form.querySelectorAll('fieldset')];

  const readJson = (id) => {
    const el = document.getElementById(id);
    try { return el ? JSON.parse(el.textContent) : {}; } catch { return {}; }
  };
  const TIERS = readJson('aiofm-tier-data');
  const CHAPTERS = readJson('aiofm-layer-map');

  const WHY = {
    t1: 'You have not spent anything yet, and the expensive mistake at this point is doing the right things in the wrong order. This is the whole stack once, end to end.',
    t2: 'You do not need the whale and hiring chapters yet — you do not have a subscriber. You do need the ones that sit between posting and money.',
    t3: 'Your ceiling is almost never content quality. It is traffic sources, accounts that survived long enough to compound, and the conversations that develop high-value subscribers.',
    t4: 'Your problem is no longer knowledge. It is making the procedure repeatable in someone else’s hands, and surviving the loss of an account without losing the business.',
  };

  const WONT = {
    t1: 'It will not tell you what you will make. What it gives you is the order, and the costs you avoid by knowing it.',
    t2: 'It will not promise your reach comes back. A badly anchored account sometimes cannot be fixed, and a fresh one reaches profit faster.',
    t3: 'It will not multiply your revenue. It tells you which layer is actually broken, so you stop repairing layer 5 when layer 3 is the problem.',
    t4: 'It will not get your account or your balance back. The manual says to assume both are gone.',
  };

  const GOAL = {
    job: 'You said you want this to replace a job. The chapters that decide that are unit economics and team — not the ones about posting more.',
    side: 'You said you want this next to something else. Then the weekly operating chapter matters more than the volume ones.',
    handoff: 'You said you want to hand this off eventually. That is SOPs, the hiring pack and access control.',
    proof: 'You said you want to know if this is real first. Read the chapter on what was tested and produced nothing before you spend on credits.',
  };

  // Obie reguly sa sprawdzalne w manifest.json - to nie sa chwyty.
  // Egzekwuja je testy generatora (zadanie 1).
  const NUDGE = {
    trust: {
      tiers: ['t1', 't2'],
      text: 'The chapters for what you just described start in SCALE — warm-up and ban forensics.',
      to: 't3',
    },
    systems: {
      tiers: ['t1', 't2', 't3'],
      text: 'SOPs, the hiring pack and the agency chapters are in COMMAND.',
      to: 't4',
    },
  };

  const state = { a: null, b: [], c: null, d: [] };
  let step = 0;

  // "Nothing yet" wyklucza pozostale i pomija pytanie 3: pytanie o to,
  // gdzie sie zatrzymalo, nie ma sensu dla kogos, kto nie zaczal.
  const exclusive = form.querySelector('[data-exclusive]');
  form.querySelectorAll('input[name="b"]').forEach((el) => {
    el.addEventListener('change', () => {
      if (!el.checked) return;
      if (el === exclusive) {
        form.querySelectorAll('input[name="b"]').forEach((o) => { if (o !== el) o.checked = false; });
      } else if (exclusive) {
        exclusive.checked = false;
      }
    });
  });

  const skipsC = () => state.b.length === 0 || state.b.includes('none');

  const readStep = () => {
    const fs = steps[step];
    const q = fs.dataset.q;
    if (q === 'a' || q === 'c') {
      const hit = fs.querySelector('input:checked');
      state[q] = hit ? hit.value : null;
      return q === 'c' ? true : Boolean(state.a);
    }
    state[q] = [...fs.querySelectorAll('input:checked')].map((el) => el.value);
    return true;
  };

  const show = () => {
    steps.forEach((fs, i) => { fs.hidden = i !== step; });
    backBtn.hidden = step === 0;
    nextBtn.textContent = step === steps.length - 1 ? 'See my tier' : 'Next';
    progress.textContent = `Question ${step + 1} of ${steps.length}`;
    const first = steps[step].querySelector('input');
    if (first) first.focus();
  };

  nextBtn.addEventListener('click', () => {
    if (!readStep()) {
      progress.textContent = 'Pick one to continue.';
      steps[step].querySelector('input')?.focus();
      return;
    }
    let n = step + 1;
    if (n === 2 && skipsC()) { state.c = null; n = 3; }
    if (n >= steps.length) { finish(); return; }
    step = n;
    show();
  });

  backBtn.addEventListener('click', () => {
    let n = step - 1;
    if (n === 2 && skipsC()) n = 1;
    step = Math.max(0, n);
    show();
  });

  const tierKey = () => (state.a === 't4r' ? 't4' : state.a);

  const labelOf = (name, value) => {
    const el = form.querySelector(`input[name="${name}"][value="${CSS.escape(value)}"]`);
    return el ? el.parentElement.textContent.trim() : value;
  };

  const el = (tag, cls, text) => {
    const n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  };

  function finish() {
    const key = tierKey();
    const tier = TIERS[key];
    if (!tier) return;

    const layer = state.c && state.c !== 'none' ? state.c : null;
    // Brak klucza NIE jest bledem: STARTER nie ma zadnego rozdzialu
    // "systems", wiec generator go nie emituje. Wtedy sekcja rozdzialow
    // sie nie renderuje, a zdanie nadpisania - tak.
    const chapters = layer ? CHAPTERS[`${key}:${layer}`] || [] : [];
    const nudge = layer && NUDGE[layer] && NUDGE[layer].tiers.includes(key)
      ? NUDGE[layer] : null;

    out.replaceChildren();

    // --- co powiedzial o sobie ---
    const summary = el('dl', 'aiofm-result-summary');
    const row = (k, v) => { summary.append(el('dt', null, k), el('dd', null, v)); };
    row('You are here', labelOf('a', state.a));
    if (layer) row("What's broken", labelOf('c', state.c));
    if (state.d.length) row('What you want', state.d.map((g) => labelOf('d', g)).join('; '));
    out.append(summary);

    // --- rekomendacja ---
    out.append(el('p', 'aiofm-note', 'THE AI OFM OPERATING SYSTEM'));
    out.append(el('h2', null, tier.name));
    out.append(el('p', 'aiofm-pdp-meta', tier.price));

    out.append(el('h3', null, 'Why this one, and not the one on either side'));
    out.append(el('p', null, WHY[key]));

    if (chapters.length) {
      out.append(el('h3', null, 'The chapters for what you just described'));
      const ul = el('ul', 'aiofm-result-chapters');
      chapters.forEach((c) => ul.append(el('li', null, `${c.no} · ${c.title}`)));
      out.append(ul);
    }

    if (nudge) {
      const p = el('p', 'aiofm-nudge');
      p.append(document.createTextNode(nudge.text + ' '));
      const a = el('a', null, `See ${TIERS[nudge.to]?.name || 'the higher tier'}`);
      a.href = TIERS[nudge.to]?.url || '#';
      p.append(a);
      out.append(p);
    }

    const goals = state.d.map((g) => GOAL[g]).filter(Boolean);
    if (goals.length) {
      out.append(el('h3', null, 'On what you said you want'));
      goals.forEach((g) => out.append(el('p', null, g)));
    }

    out.append(el('h3', null, 'One thing it will not do'));
    out.append(el('p', null, WONT[key]));

    // --- przycisk zakupu: gotowy blok z Liquid, nie sklejany w JS ---
    const buy = pool?.querySelector(`[data-aiofm-buy-for="${key}"]`);
    if (buy) out.append(buy);

    const more = el('p');
    const link = el('a', null, `See everything in ${tier.name} first`);
    link.href = tier.url;
    more.append(link);
    out.append(more);

    form.hidden = true;
    out.hidden = false;
    out.focus();

    // pushState, nie replaceState: wynik ma byc wpisem w historii, zeby
    // WSTECZ wracalo do pytan, a nie wyrzucalo ze strony. Warunek chroni
    // przed dublowaniem wpisu, gdy ktos wszedl juz z gotowym linkiem.
    const hash = `a=${state.a}&b=${state.b.join('.')}&c=${state.c || ''}&d=${state.d.join('.')}`;
    if (location.hash.slice(1) !== hash) history.pushState(null, '', `#${hash}`);
  }

  const restore = () => {
    const p = new URLSearchParams(location.hash.slice(1));
    if (!p.get('a')) return false;
    state.a = p.get('a');
    state.b = (p.get('b') || '').split('.').filter(Boolean);
    state.c = p.get('c') || null;
    state.d = (p.get('d') || '').split('.').filter(Boolean);
    // Odtworz zaznaczenia, zeby przycisk Back mial co pokazac.
    form.querySelectorAll('input').forEach((i) => {
      const v = state[i.name];
      i.checked = Array.isArray(v) ? v.includes(i.value) : v === i.value;
    });
    finish();
    return true;
  };

  const reset = () => {
    step = 0;
    state.a = null; state.b = []; state.c = null; state.d = [];
    form.querySelectorAll('input').forEach((i) => { i.checked = false; });
    out.replaceChildren();
    out.hidden = true;
    form.hidden = false;
    show();
  };

  form.hidden = false;
  if (!restore()) show();

  // Bez tego przycisk WSTECZ po ukonczeniu quizu zmienia hash, ale nic sie
  // nie przerysowuje - czlowiek zostaje na starym wyniku. Zmiana hasha
  // w tym samym dokumencie nie przeladowuje skryptu.
  window.addEventListener('hashchange', () => {
    if (!restore()) reset();
  });
})();
